import React from 'react';

import styled from 'styled-components';

import Modal from 'components/lib/Modal';

const Body = styled.div`
  padding: 20px 0 30px;
`;

const Subtitle = styled.div`
  font-size: 13px;
  color: var(--text-secondary);
  margin-top: 4px;
`;

const Title = styled.div`
  font-size: 20px;
  font-family: var(--font-bold);
`;

type Props = {
  open: boolean;
  title: string;
  subtitle?: string;
  onClose: () => void;
  children: React.ReactNode;
};

const MyCommunitiesDetailsModal = ({ open, title, subtitle, onClose, children }: Props) => (
  <Modal
    open={open}
    onCancel={onClose}
    footer={null}
    width={1100}
    destroyOnClose
    transitionName=""
    maskTransitionName=""
    title={
      <div>
        <Title>{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </div>
    }
  >
    <Body>{children}</Body>
  </Modal>
);

export default MyCommunitiesDetailsModal;
